import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Calendar,
  kilometers,
  location,
  moneyWhite,
  carIcon,
} from '../../assets/icons';
import { MConfirmation } from '../index';
import { defaultLettersCircle, languageAr } from '../../helpers/helper';
import CarColor from './CarColor';
import { getConfirmationRequest } from '../../services/apis/order';

const MCardOfferDetails = ({
  carOffer,
  commision,
  from,
  offer,
  finalOffer,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [openModalCars, setOpenModalCars] = useState(false);
  const [showImage, setShowImage] = useState(null);

  const [confirmation, setConfirmation] = useState(null);
  useEffect(() => {
    if (finalOffer) {
      getConfirmationRequestData();
    }
  }, []);

  const getConfirmationRequestData = async () => {
    const response = await getConfirmationRequest('', finalOffer);
    setConfirmation(response.data);
  };

  const validImages = offer?.carFiles?.filter(item => 
    /\.(jpg|jpeg|png)$/i.test(item)
  );

  const validFiles = offer?.carFiles?.filter(item => 
    /\.(pdf|doc|docx|xlsx|xls)$/i.test(item)
  );

  return (
    <div
      className="w-[100%] bg-[#D7E2FF] rounded-[20px] mr-auto ml-auto"
      style={{ direction: languageAr ? 'rtl' : 'ltr' }}
    >
      <div className="flex flex-row justify-between">
      </div>
      <div className="grid grid-cols-[40%_60%] max800:grid-cols-1 p-5">
        <div className="flex flex-col p-2">
          {!offer?.car ? null : (
            <div className="flex flex-row items-center">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.cars')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <img
                      src={offer?.car?.image}
                      className="w-[20px] h-[20px]"
                    />
                  </div>
                  <div className="text-[#0000000] text-[12px] font-400 px-2">
                    {languageAr
                      ? offer?.car?.brand
                      : offer?.car?.brandEn}
                  </div>
                </div>
              </div>
            </div>
          )}
          {!offer?.car?.model ? null : (
            <div className="flex flex-row items-center mt-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.category')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <img src={carIcon} className="w-[20px] h-[20px]" />
                  </div>
                  <div className="text-[#0000000] text-[12px] font-400 px-2">
                    {languageAr
                      ? offer?.car?.model?.brandTypes
                      : offer?.car?.model?.brandTypesEn}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!offer?.city ? null : (
            <div className="flex flex-row items-center mt-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.city')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <img src={location} className="w-[20px] h-[20px]" />
                  </div>
                  <div className="text-[#0000000] text-[12px] font-400 px-2">
                    {languageAr
                      ? offer?.city?.city
                      : offer?.city?.cityEn}
                  </div>
                </div>
              </div>
            </div>
          )}
          {!offer?.odo ? null : (
            <div className="flex flex-row items-center my-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.km')}:
              </div>
              <div className="flex flex-row bg-[#E6EDFF] rounded-[12px] p-2 mx-2">
                <div>
                  <img src={kilometers} className="w-[20px] h-[20px]" />
                </div>
                <div className="flex flex-row items-center px-2">
                  <div className="text-[#BBBBBB] text-[10px] font-400">
                    {t('listOrders.from')}
                  </div>
                  <div className="text-[#000000] text-[13px] font-400 px-2">
                    {offer.odo}
                  </div>
                  <div className="text-[#BBBBBB] text-[10px] font-400">
                    {t('listOrders.km')}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!offer?.color ? null : (
            <div className="flex flex-row items-center">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.color')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <CarColor
                      color={
                        offer?.color?.hexCode == '#FFFFFF'
                          ? '#808080'
                          : offer?.color?.hexCode
                      }
                    />{' '}
                  </div>
                  <div
                    style={{
                      color:
                        offer?.color?.hexCode == '#FFFFFF'
                          ? '#808080'
                          : offer?.color?.hexCode,
                    }}
                    className="text-[12px] font-400 px-2"
                  >
                    {languageAr
                      ? offer?.color?.nameAr
                      : offer?.color?.nameEn}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-row items-center my-3">
            <div className="text-[#3E0292] text-[14px] font-500">
              {t('offerDetails.price')}:
            </div>
            <div className="flex flex-row bg-[#00CEBC] rounded-[12px] p-2 mx-2">
              <div>
                <img src={moneyWhite} className="w-[20px] h-[20px]" />
              </div>
              <div className="flex flex-row items-center px-2">
                <div className="text-[12px] font-500 text-[#ffffff]">
                  {t('listOrders.price')}
                </div>
                <div className="text-[12px] font-500 text-[#ffffff] px-2">
                  :
                </div>
                <div className="text-[12px] font-500 text-[#ffffff] px-2">
                  {offer?.price}
                </div>
                <div className="text-[12px] font-500 text-[#ffffff]">
                  {t('listOrders.Rial')}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-row items-center">
            <div className="text-[#3E0292] text-[14px] font-500">
              {t('offerDetails.commission')}:
            </div>
            <div className="flex flex-row bg-[#04C500CC] rounded-[12px] p-2 mx-2">
              <div>
                <img src={moneyWhite} className="w-[20px] h-[20px]" />
              </div>
              <div className="flex flex-row items-center px-2">
                <div className="text-[12px] font-500 text-[#ffffff] px-2">
                  {commision ? commision : offer?.commission}
                </div>
                {offer.commissionType == "CASH" ? (
                  <div className="text-[12px] font-500 text-[#ffffff]">
                    {t('listOrders.Rial')}
                  </div>
                ):null}
              </div>
            </div>
          </div>
          {!confirmation?.invoiceUrl ? null : (
            <div className="flex flex-row items-center my-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('listOrders.invoice')}:
              </div>
              <div className="flex flex-row bg-[#3E0292] rounded-[12px] p-2 mx-2">
                <div>
                  <img src={moneyWhite} className="w-[20px] h-[20px]" />
                </div>
                <div
                  className="text-[12px] font-500 text-[#ffffff] px-2"
                  onClick={() =>
                    (window.location.href = confirmation?.invoiceUrl)
                  }
                >
                  {t('offerDetails.downloadInvoice')}
                </div>

              </div>
            </div>
          )}
        </div>
        <div
          className={`flex flex-col border max800:border-0 ${languageAr ? 'border-r-[#ffffff]' : 'border-l-[#ffffff]'} p-3`}
        >
          <div className="flex flex-row items-center">
            <div className="text-[#3E0292] text-[14px] font-500">
              {' '}
              {t('offerDetails.year')}:
            </div>
            <div className="flex flex-row bg-[#ffffff] rounded-[12px] p-2 mx-2">
              <div>
                <img src={Calendar} className="w-[20px] h-[20px]" />
              </div>
              <div className="flex flex-row items-center px-2">
                <div className="text-[#000000] text-[13px] font-[600px] px-2">
                  {offer?.modelYear}
                </div>
              </div>
            </div>
          </div>
          {offer?.description == '' ? null : (
            <div className="flex flex-row items-center mt-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {' '}
                {t('offerDetails.description')}:
              </div>
              <div className="flex flex-row bg-[#ffffff] rounded-[12px] p-2 mx-2">
                <div className="text-[#303030] text-[14px] font-400">
                  {offer?.description}
                </div>
              </div>
            </div>
          )}


          {validImages?.length == 0 ? null : (
            <div className="flex flex-col my-3 cursor-pointer">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('orderDetails.images')}:
              </div>
              <div className="bg-[#ffffff] rounded-[12px] p-2 mx-2">
                <div className="grid xl:grid-cols-3 2xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 max600:grid-cols-1 sm:grid-cols-2 gap-2">
                  {validImages?.map((image, index) => (
                    <div key={index} onClick={() => setOpenModalCars(true,setShowImage(image))}>
                      <img
                        src={image}
                        className="h-[100px] w-[100%] rounded-[5px] border-[0.5px] border-[#999999]"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}


         {validFiles?.length == 0 ? null : (
            <div className="flex flex-col my-3 cursor-pointer">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('orderDetails.files')}:
              </div>
              <div className="bg-[#ffffff] rounded-[12px] p-2 mx-2">
                <div className="grid xl:grid-cols-3 2xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 max600:grid-cols-1 sm:grid-cols-2 gap-2">
                  {validFiles?.map((file, index) => (
                    <div key={index}>
                      <div className="text-[#3E0292] text-[13px] font-500 underline" onClick={() => (window.location.href = file)}>{t('myOrders.file') +" "+ index+1}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <MConfirmation
        openModal={openModalCars}
        setOpenModal={setOpenModalCars}
        title={t('orderDetails.images')}
        content={
        <div className="h-56 sm:h-64 xl:h-80 2xl:h-96 carousel-container" style={{ direction: 'ltr' }}>
          <div style={{ direction: languageAr ? 'rtl' : 'ltr' }}>
            <img
              src={showImage}
              className="h-56 sm:h-64 xl:h-80 2xl:h-96 w-[100%]"
              alt={`image`}
            />
          </div>
      </div>
        }
      />
    </div>
  );
};

export default MCardOfferDetails;
